module.exports = __webpack_public_path__ + "direct-es2015.916a3481884687aa2aab.worker.js"